import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import MsalAuthProvider from 'common/components/custom/msal-auth-provider';
import configureStore from 'common/redux/core/store.config';
import { injectStore } from 'common/services/http-interceptor';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import AccessProvider from 'common/providers/AccessProvider';

// To ensure nothing is logged in browser window in production mode
if (window) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window.console.log = function () {};
}

const store = configureStore();
injectStore(store);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <MsalAuthProvider>
                <AccessProvider>
                    <App />
                </AccessProvider>
            </MsalAuthProvider>
        </BrowserRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
